export default "* Sanke\n* Genkende\n* Forveksle\n* Spiselig\n";